import _regeneratorRuntime from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Component } from 'react';
import Utils from '../../utils';
import GameListInterface from '../../api/GameListInterface';
import { counterTypes } from '../../utils/TimestampManager';
import transformObjectArrayResponse from '../../utils/transformObjectArrayResponse';
import { fetchGameRooms } from '../../state/query/games/utils';

var TimeRemainingText = /*#__PURE__*/function (_Component) {
  _inherits(TimeRemainingText, _Component);

  var _super = _createSuper(TimeRemainingText);

  function TimeRemainingText() {
    var _this;

    _classCallCheck(this, TimeRemainingText);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.state = {
      now: new Date()
    };
    _this.timer = null;

    _this.checkToKeepEvent = function (eventType, endTimerCallback) {
      if (eventType === counterTypes.SNEAK_PEEK) {
        endTimerCallback && endTimerCallback();
        fetchGameRooms(true);

        _this._fetchFavourites();
      }
    };

    _this._fetchFavourites = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var fetchedFavGames, favouriteGames;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return GameListInterface.getFavGames();

            case 3:
              fetchedFavGames = _context.sent;
              favouriteGames = transformObjectArrayResponse(fetchedFavGames.FAVOURITE_GAMES);

              _this.props.setFavouriteGames(favouriteGames); // eslint-disable-next-line no-empty


              _context.next = 10;
              break;

            case 8:
              _context.prev = 8;
              _context.t0 = _context["catch"](0);

            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 8]]);
    }));
    return _this;
  }

  _createClass(TimeRemainingText, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      this.timer = setInterval(function () {
        return _this2.setState({
          now: new Date()
        });
      }, this.props.interval || 1000);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearInterval(this.timer);
    }
  }, {
    key: "render",
    value: function render() {
      var string = '';
      var now = this.state.now;
      var _this$props = this.props,
          activeTutorial = _this$props.activeTutorial,
          until = _this$props.until,
          _this$props$prefix = _this$props.prefix,
          prefix = _this$props$prefix === void 0 ? '' : _this$props$prefix,
          _this$props$postfix = _this$props.postfix,
          postfix = _this$props$postfix === void 0 ? '' : _this$props$postfix,
          _this$props$hideOnFin = _this$props.hideOnFinish,
          hideOnFinish = _this$props$hideOnFin === void 0 ? false : _this$props$hideOnFin,
          hideTimer = _this$props.hideTimer,
          hideTimerOnFinish = _this$props.hideTimerOnFinish,
          counterType = _this$props.counterType,
          endTimerCallback = _this$props.endTimerCallback,
          shouldShowTooltip = _this$props.shouldShowTooltip,
          tooltipDetails = _this$props.tooltipDetails,
          modal = _this$props.modal,
          inNavBar = _this$props.inNavBar,
          showMissionsProgressBar = _this$props.showMissionsProgressBar,
          setShowMissionsProgressBar = _this$props.setShowMissionsProgressBar;
      var secureUntil = until || new Date();

      var _Utils$buildTimeRemai = Utils.buildTimeRemaining(now, secureUntil, counterType),
          timeString = _Utils$buildTimeRemai.timeString,
          isTimeInDanger = _Utils$buildTimeRemai.isTimeInDanger;

      if (timeString && timeString !== '00:00:00') {
        string = "".concat(prefix).concat(timeString).concat(postfix);
      } else {
        this.checkToKeepEvent(counterType, endTimerCallback);
        if (hideOnFinish) return null;

        if (!hideTimer) {
          hideTimerOnFinish(true);
        }

        string = '...';

        if (counterType === counterTypes.MISSION_CARD) {
          string = "".concat(prefix, "00h 00m");
          isTimeInDanger = true;
        }

        if (counterType === counterTypes.MISSION_GRAND_CARD) {
          string = "".concat(prefix, "00d 00h");
          isTimeInDanger = true;
        }
      }

      if (counterType === counterTypes.MISSION_CARD && inNavBar && showMissionsProgressBar && secureUntil - now <= 0) setShowMissionsProgressBar(false);
      return this.props.render({
        string: string,
        isTimeInDanger: isTimeInDanger,
        shouldShowTooltip: shouldShowTooltip,
        tooltipDetails: tooltipDetails,
        modal: modal,
        showMissionsProgressBar: showMissionsProgressBar,
        activeTutorial: activeTutorial
      });
    }
  }]);

  return TimeRemainingText;
}(Component);

export { TimeRemainingText as default };